module.exports = __webpack_public_path__ + "static/media/arrows.22f01db1.svg";